import { orange, purple } from "@flat-ui";

/**
 * Named waypoint colors — single source of truth for all color references.
 * These are persisted to the backend, so they must stay fixed hex values, never theme variables.
 */
export const WAYPOINT_COLORS = {
  RED: "#E50505",
  ORANGE: orange[400],
  YELLOW: "#FFCC4C",
  GREEN: "#12B058",
  BLUE: "#1F65F0",
  PURPLE: purple[500]
};

/**
 * Waypoint color palette for color picker in settings.
 * Automatically derived from WAYPOINT_COLORS — changes to colors are reflected here.
 */
export const WAYPOINT_COLOR_PALETTE = Object.values(WAYPOINT_COLORS);

/**
 * Default waypoint color used when no custom color has been set.
 * Always references WAYPOINT_COLORS.BLUE — guaranteed to be in sync with the palette.
 */
export const DEFAULT_WAYPOINT_COLOR = WAYPOINT_COLORS.BLUE;